import WebGalleryThumbnailActions from './WebGalleryThumbnailActions';

export default WebGalleryThumbnailActions;
